import { render, staticRenderFns } from "./TermsOp.vue?vue&type=template&id=c519b68a&"
import script from "./TermsOp.vue?vue&type=script&lang=ts&"
export * from "./TermsOp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports